import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import renderField from '../../../../customInputs/renderField';
import FilterActions from '../../../../common/filterActions/FilterActions'
import validate from './validation';
import renderMultiSelectSearch from '../../../../customInputs/renderMultiSelectSearch';

class FilterFiles extends React.Component {
  constructor(props) {
    super(props);
    this.initialFormIdOptions = props.formIdOptions;
  }

  render() {
    const {
      title,
      keywords,
      startDate,
      endDate,
      formIds
    } = this.props.local.strings.scProfile.files.filter;

    const {handleSubmit} = this.props;

    return (
      <form onSubmit={handleSubmit} className="list-view-filter-form files-filter-form">
        <h2 className="list-view-filter-title">{title}</h2>
        <div className="container-fluid filter-fields">
          <div className="row">
            <div className="col-md-3 col-sm-12 no-padd">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="keywords">{keywords}: </label>
                <Field
                  name="keywords"
                  type="text"
                  placeholder={`--${keywords}--`}
                  component={renderField}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-12 no-padd">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="date">{startDate}: </label>
                <Field
                  name="dateFrom"
                  type="date"
                  component={renderField}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-12 no-padd">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="date">{endDate}: </label>
                <Field
                  name="dateTo"
                  type="date"
                  component={renderField}
                />
              </div>
            </div>
            <div className="col-md-3 col-sm-12 no-padd">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="date">{formIds}: </label>
                <Field
                  name="formIds"
                  component={renderMultiSelectSearch}
                  type="select"
                  multiple
                  options={this.props.formIdOptions}
                  key={JSON.stringify(this.props.formIdOptions)}
                />
              </div>
            </div>

            <FilterActions
              formName={this.props.form}
              dispatch={this.props.dispatch} />

          </div>
        </div>
      </form>

    );
  }
}

FilterFiles = reduxForm({
  form: 'FilterFilesForm',
  validate,
  enableReinitialize: true, 
})(FilterFiles);

const mapStateToProps = (state) => {
  let formIdOptions = state.files.savedFormIds && Array.isArray(state.files.savedFormIds)
    ? state.files.savedFormIds
        .filter((savedForm) => savedForm && savedForm.savedFormId && savedForm.fileTypeId)
        .reduce((acc, savedForm) => {
          const formId =  savedForm.fileTypeId === 2 ? {label: "NULL", value: savedForm.savedFormId} : {label: savedForm.savedFormId, value: savedForm.savedFormId};
          if (formId.label == "NULL") {
            if (acc[formId.label]) {
              acc[formId.label].value = {
                [formId.value]: formId.value
              }
              return acc;
            }
          }
          return {
            ...acc,
            [`${formId.label}`]: {label: formId.label, value: {[formId.value]: formId.value}}
          }
        }, {})
    : {};

  formIdOptions = Object.values(formIdOptions).map((item) => {
    item.value = Object.keys(item.value).join(',')
    return item
  })

  const nullOption = formIdOptions.filter(fo => fo.label === 'NULL');
  let restOptions = formIdOptions.filter(fo => !isNaN(fo.label));

  restOptions.sort(function(a, b) {
    var aNum = Number(a.label);
    var bNum = Number(b.label);
    return  bNum - aNum
  });
  
  const sortedFormIdOptions = [...nullOption, ...restOptions];

  return {
    local: state.localization,
    login: state.login,
    scProfile: state.SCProfile,
    formIdOptions: sortedFormIdOptions
  };
};

export default connect(mapStateToProps)(FilterFiles);
